/*
 * Copyright (c) 2021. Lukas Tschaftary
 *
 * NOTICE:  All information contained herein is, and remains the property of Lukas Tschaftary and his suppliers, if any. 
 * The intellectual and technical concepts contained herein are proprietary to Lukas Tschaftary and its suppliers and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law. 
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained from Lukas Tschaftary.
 */

import React from 'react';

const debounce = (func, delay) => {
    let inDebounce
    return function () {
        const context = this
        const args = arguments
        clearTimeout(inDebounce)
        inDebounce = setTimeout(() => func.apply(context, args), delay)
    }
}
const DebouncedFunction = debounce((handler, query) => handler(query), 400);


class ContentFitComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            scale: 1
        }


        this.wrap = React.createRef()
        this.outer = React.createRef()


    }

    componentDidMount() {
        this.fitToBoundary()

    }

    fitToBoundary() {
        if (this.wrap.current !== null) {

            let wrapper = this.wrap.current.getBoundingClientRect()
            let content = this.outer.current.getBoundingClientRect()
            let scaleX = (content.height / wrapper.height * this.state.scale).toPrecision(3)
            let scaleY = (content.width / wrapper.width * this.state.scale).toPrecision(3)
            let scale = Math.max(scaleY, scaleX)
            console.log(scale);

            if (this.state.scale !== scale) {
                this.setState({scale: scale})
            }

        }
    }

    componentDidUpdate(prevProps: Readonly<P>, prevState: Readonly<S>, snapshot: SS) {
        DebouncedFunction(function () {
            this.fitToBoundary()
        }.bind(this))

    }

    render() {
        return (
            <div ref={this.wrap} style={{
                position: "relative",
                width: "100%",
                height: "100%",
                overflow: "hidden"

            }}>
                <div ref={this.outer} style={{
                    position: "relative",
                    width: "300px",
                    height: "300px",
                    left: "50%",
                    top: "50%",
                    willChange: 'transform',
                    transform: 'translate(-50%, -50%) scale(' + (1 / this.state.scale) + ')',
                    transformOrigin: "center"
                }} className={"transition-transform ease-in-out duration-300"}>
                    {this.props.children}

                </div>

            </div>
        );
    }
}

ContentFitComponent.propTypes = {};

export default ContentFitComponent;